import type { Context } from '@white-label-types/middleware';

const auth = ({ app, redirect }: Context) => {
  if (process.client && !app['$auth'].isAuthenticated) {
    redirect('/login');
  }
}

export default auth;
